export default __webpack_public_path__ + "static/media/520.0eff3155.gif";